<ng-container *ngIf="stringParts$ | async as stringParts" [ngSwitch]="nodeType">
    <ng-container *ngSwitchCase="HtmlParserNodeType.span" [ngTemplateOutlet]="spanNodes"></ng-container>
    <ng-container *ngSwitchCase="HtmlParserNodeType.div" [ngTemplateOutlet]="divNodes"></ng-container>
    <ng-container *ngSwitchCase="HtmlParserNodeType.p" [ngTemplateOutlet]="pNodes"></ng-container>

    <ng-template #spanNodes>
        <span *ngFor="let part of stringParts" [ngClass]="part.classes">{{part.message}}</span>
    </ng-template>
    <ng-template #divNodes>
        <div *ngFor="let part of stringParts" [ngClass]="part.classes">{{part.message}}</div>
    </ng-template>
    <ng-template #pNodes>
        <p *ngFor="let part of stringParts" [ngClass]="part.classes">{{part.message}}</p>
    </ng-template>
</ng-container>
